<div class="header">
  <h1>Explore our apps</h1>
</div>

<mat-divider class="header1"></mat-divider>

<div class="nav-buttons">
  <h2>Filter by Categories</h2>
  <nav>
    <a
      *ngFor="let category of categories"
      [attr.data-testid]="category"
      class="nav-button"
      mat-ripple
      routerLink="/browse/{{ category }}"
      routerLinkActive="selected">
      {{ category | categoryName }}
    </a>
  </nav>
</div>

<mat-divider class="header2"></mat-divider>
